import { useState } from 'react'
import { IProjectCheckpointArtifact } from 'screens/Admin/ProjectCheckpoints/projectCheckpoints.types'
import { ArtifactInspectionData } from 'screens/Projects/projects.types'
import { getDefaultData } from 'screens/ProjectCheckpoints/utils/getDefaultData'
import Button from 'shared/Buttons/Button/Button'
import TextField from 'shared/Forms/TextField'
import FileInput from 'shared/Inputs/FileInput'
import Textarea from 'shared/Inputs/Textarea'
import Modal from 'shared/Modal'
import ModalHeader from 'shared/Modal/ModalHeader'
import Tag from 'shared/Tag'

interface IProps {
  onClose: () => void
  artifacts: IProjectCheckpointArtifact[]
  onSave: (data: ArtifactInspectionData['artefacts']) => void
}

const SendWorkModal = (props: IProps) => {
  const [filledArtifacts, setFilledArtifacts] = useState<Record<string, string | File | undefined>>(
    getDefaultData(props.artifacts)
  )

  const handleTextChange = (val: string, name: string) => {
    setFilledArtifacts({ ...filledArtifacts, [name]: val })
  }

  const handleFileChange = (id: string) => (_, file: File) => {
    setFilledArtifacts({ ...filledArtifacts, [id]: file })
  }

  const removeFile = (id: string) => () => {
    setFilledArtifacts({ ...filledArtifacts, [id]: undefined })
  }

  const handleSend = () => {
    const data: ArtifactInspectionData['artefacts'] = props.artifacts.map((artifact) => ({
      projectCheckpointExpectedArtefactId: artifact.id,
      text: artifact.type === 'TEXT' ? (filledArtifacts[artifact.id] as string) : undefined,
      file: artifact.type === 'FILE' ? (filledArtifacts[artifact.id] as File) : undefined,
    }))

    props.onSave(data)
  }

  const canSave = props.artifacts.every((artifact) => {
    if (!artifact.required) return true
    const art = filledArtifacts[artifact.id]
    if (artifact.type === 'TEXT')
      return !!art && (art as string).length >= artifact.minSymbols && (art as string).length <= artifact.maxSymbols
    return filledArtifacts[artifact.id] !== undefined
  })

  return (
    <Modal onClose={props.onClose} size='sm' shouldAnimate={false}>
      <ModalHeader onClose={props.onClose}>Материалы для проверки</ModalHeader>
      <div className='modal-content flex-lines' style={{ height: '60vh' }}>
        {props.artifacts.map((artifact) => (
          <div key={artifact.id} className='flex-lines'>
            <TextField header={`${artifact.title}${artifact.required ? '*' : ''}`}>
              <p style={{ marginBottom: '4px' }} className='text--body-s text--secondary'>
                {artifact.description}
              </p>
              {artifact.type === 'TEXT' && (
                <div>
                  <Textarea
                    value={filledArtifacts[artifact.id] as string}
                    name={artifact.id}
                    onChange={handleTextChange}
                    required={artifact.required}
                    maxLength={artifact.maxSymbols}
                    minLength={artifact.minSymbols}
                  />
                  <p className='text--body-s text--secondary'>
                    от {artifact.minSymbols} до {artifact.maxSymbols} символов
                  </p>
                </div>
              )}
              {artifact.type === 'FILE' && (
                <div className='flex-space-between'>
                  <FileInput
                    accept='application/pdf, image/*,doc,docx'
                    buttonClass='grey-outline'
                    onChange={handleFileChange(artifact.id)}
                  >
                    Загрузить
                  </FileInput>
                  {filledArtifacts[artifact.id] && (
                    <Tag label={(filledArtifacts[artifact.id] as File).name} onDelete={removeFile(artifact.id)} />
                  )}
                </div>
              )}
            </TextField>
          </div>
        ))}
      </div>
      <div className='modal-footer'>
        <Button theme='grey-outline' fullWidth={false} onClick={props.onClose}>
          Отмена
        </Button>
        <Button theme='primary' fullWidth={false} disabled={!canSave} onClick={handleSend}>
          Отправить на проверку
        </Button>
      </div>
    </Modal>
  )
}

export default SendWorkModal
